/** Harta orașului din jurul lotului, adusă de la server și cerută din nou cât
 *  timp serverul o mai completează (`complet: false`): prima cerere pentru o
 *  zonă nouă întoarce ce e gata și pornește aducerea restului în fundal. */

import { useEffect, useState } from "react";
import { get } from "../../api";
import type { RaspunsOras } from "./tipuri";

/** Raza implicită a hărții, în metri. */
export const RAZA_ORAS_M = 2000;
/** La cât timp se întreabă din nou cât se aduce orașul. */
const REIA_MS = 6000;
/** Câte reveniri, cel mult: o dală care nu vine în ~20 de minute nu mai vine. */
const REVENIRI_MAX = 200;

export const caleHarta = (nord: number, est: number, raza: number) =>
  `/api/geo/oras?nord=${nord.toFixed(1)}&est=${est.toFixed(1)}&raza=${Math.round(raza)}`;

/** `null` cât nu e nimic de arătat (sau harta e oprită). Centrul se rotunjește
 *  la 10 m, ca o soluție nouă a aceluiași lot să nu ceară altă hartă. */
export function useHartaOras(centru: { nord: number; est: number } | null,
                             raza: number = RAZA_ORAS_M): RaspunsOras | null {
  const [harta, setHarta] = useState<RaspunsOras | null>(null);
  const nord = centru ? Math.round(centru.nord / 10) * 10 : null;
  const est = centru ? Math.round(centru.est / 10) * 10 : null;

  useEffect(() => {
    if (nord == null || est == null) { setHarta(null); return; }
    let viu = true;
    let ceas: ReturnType<typeof setTimeout> | undefined;
    let reveniri = 0;
    let ultimeleGata = -1;
    const cere = () => {
      get<RaspunsOras>(caleHarta(nord, est, raza), { silent: true })
        .then((r) => {
          if (!viu) return;
          // aceeași hartă ca data trecută: nu se reconstruiește nimic
          if (r.dale.gata !== ultimeleGata || r.complet) {
            ultimeleGata = r.dale.gata;
            setHarta(r);
          }
          if (!r.complet && ++reveniri < REVENIRI_MAX) ceas = setTimeout(cere, REIA_MS);
        })
        // harta e decor: o cerere picată se reîncearcă, nu se anunță
        .catch(() => {
          if (viu && ++reveniri < REVENIRI_MAX) ceas = setTimeout(cere, REIA_MS * 2);
        });
    };
    cere();
    return () => { viu = false; if (ceas) clearTimeout(ceas); };
  }, [nord, est, raza]);

  return harta;
}
